import { gql } from '@apollo/client';

const POLICY_FRAGMENT = gql`
  fragment PolicyFragment on Policy {
    id
    templateId
    policyType
    policyHtmlContent
    pdfUrl
    isAgreedTo
    agreedAt
    agreedBy
    ownerId
    tenantId
  }
`;

export const GET_POLICIES_BY_OWNER_ID = gql`
  ${POLICY_FRAGMENT}
  query GetPoliciesByOwnerId($ownerId: String!) {
    getPoliciesByOwnerId(ownerId: $ownerId) {
      ...PolicyFragment
    }
  }
`;

export const GET_POLICY = gql`
  ${POLICY_FRAGMENT}
  query GetPolicy($id: String!) {
    getPolicy(id: $id) {
      ...PolicyFragment
    }
  }
`;

export const AGREE_TO_POLICY = gql`
  ${POLICY_FRAGMENT}
  mutation AgreeToPolicy($policyId: String!) {
    agreeToPolicy(policyId: $policyId) {
      ...PolicyFragment
    }
  }
`;
